import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";

import EmployerSearch from "./etqa/employer/EmployerSearch";
import Employer from "./etqa/employer/Employer";
import AssessorSearch from "./etqa/assessor/AssessorSearch";
import AuditTrial from "./etqa/assessor/AuditTrial";
import Assessor from "./etqa/assessor/Assessor";
import BDASearch from "./etqa/bda/BDASearch";
import PersonSearch from "./etqa/person/PersonSearch";
import LearnerSearch from "./etqa/learner/LearnerSearch";
import Learner from "./etqa/learner/Learner";
import LearnerCRM from "./etqa/learner/LearnerCRM";
import Person from "./etqa/person/Person";
import LearnerSkillsProgrammeSearch from "./etqa/learner/LearnerSkillsProgram";
import LearnerEntrepreneurshipSearch from "./etqa/learner/LearnerEntrepreneurship";
import LearnerCapacityBuildingSupportSearch from "./etqa/learner/LearnerCapacityBuildingSupport";
import LearnerSeniorCertificateAssistanceSearch from "./etqa/learner/LearnerSeniorCertificateAssistance";
import LearnerDigitalLiteracySearch from "./etqa/learner/LearnerDigitalLiteracy";
import LearnerCareerGuidanceWorkshopSearch from "./etqa/learner/LearnerCareerGuidanceWorkshop";
import LearnerRPLSearch from "./etqa/learner/LearnerRPL";
import LearnerShortCourseSearch from "./etqa/learner/LearnerShortCourse";
import LearnerWILSearch from "./etqa/learner/LearnerWIL";
import LearnerMathScienceSupportSearch from "./etqa/learner/LearnerMathScienceSupport";
import LearnerWorkReadinessProgrammeSearch from "./etqa/learner/LearnerWorkReadinessProgramme";
import LearnerBursarySearch from "./etqa/learner/LearnerBursary";
import LearnerUnitStandardSearch from "./etqa/learner/LearnerUnitStandard";
import LearnerCandidacySearch from "./etqa/learner/LearnerCandidacy";
import LearnerInternshipsSearch from "./etqa/learner/LearnerInternships";
import LearnerAETSearch from "./etqa/learner/LearnerAET";
import LearnerFETSearch from "./etqa/learner/LearnerFET";
import LearnerQualificationSearch from "./etqa/learner/LearnerQualification";
import LearnerQualificationUSSearch from "./etqa/learner/LearnerQualificationUSSearch";
import LearnerModuleQualificationSearch from "./etqa/learner/LearnerModuleQualification";
import LearnerModuleQualificationUSSearch from "./etqa/learner/LearnerModuleQualificationUSSearch";
import LearnerTradeSearch from "./etqa/learner/LearnerTrade";
import LearnerTradeTestSearch from "./etqa/learner/LearnerTradeTestSearch";
import LearnerLearnershipSearch from "./etqa/learner/LearnerLearnership";
import LearnerLearnershipAchievements from "./etqa/learner/LearnerLearnershipAchievement";
import LearnerUnitStandardAchievement from "./etqa/learner/LearnerUnitStandardAchievement";
import LearnerQualificationAchievement from "./etqa/learner/LearnerQualificationAchievement";
import LearnerSkillsProgrammeAchievement from "./etqa/learner/LearnerSkillsProgrammeAchievement";
import LearnerLearnershipAssessments from "./etqa/learner/LearnerLearnershipAssessment";
import LearnerQCTOLearnershipAssessments from "./etqa/learner/LearnerQCTOLearnershipAssessment";
import ViewLearnershipAchievementUS from "./etqa/learner/ViewLearnershipAchievementUS";
import ViewSkillsProgrammeAchievementUS from "./etqa/learner/ViewSkillsProgrammeAchievementUS";
import ViewQualificationAchievementUS from "./etqa/learner/ViewQualificationAchievementUS";
import ViewLearnershipAssessment from "./etqa/learner/ViewLearnershipAssessment";
import ViewQCTOLearnershipAssessment from "./etqa/learner/ViewQCTOLearnershipAssessment";
import ViewSkillsProgrammeAssessment from "./etqa/learner/ViewSkillsProgrammeAssessment";
import ViewQCTOSkillsProgrammeAssessment from "./etqa/learner/ViewQCTOSkillsProgrammeAssessment";
import ViewQualificationAssessment from "./etqa/learner/ViewQualificationAssessment";
import ViewUnitStandardAssessment from "./etqa/learner/ViewUnitStandardAssessment";
import ViewModuleQualificationAssessment from "./etqa/learner/ViewModuleQualificationAssessment";
import ViewQCTOQualificationAssessment from "./etqa/learner/ViewQCTOQualificationAssessment";
import LearnerUnitStandardAssessment from "./etqa/learner/LearnerUnitStandardAssessment";
import LearnerQualificationAssessment from "./etqa/learner/LearnerQualificationAssessment";
import LearnerModuleQualificationAssessment from "./etqa/learner/LearnerModuleQualificationAssessment";
import LearnerQCTOQualificationAssessment from "./etqa/learner/LearnerQCTOQualificationAssessment";
import LearnerSkillsProgrammeAssessment from "./etqa/learner/LearnerSkillsProgrammeAssessment";
import LearnerQCTOSkillsProgrammeAssessment from "./etqa/learner/LearnerQCTOSkillsProgrammeAssessment";
import LearnerProgrammeGrants from "./etqa/learner/LearnerProgrammeGrants";
import LearnerTrackingSearch from "./etqa/learner/learnertracking/LearnerTrackingSearch";
import Moderator from "./etqa/moderator/Moderator";
import ModeratorSearch from "./etqa/moderator/ModeratorSearch";
import ModeratorSkillsProgramme from "./etqa/moderator/ModeratorSkillsProgramme";
import ModeratorQualification from "./etqa/moderator/ModeratorQualification";
import ModeratorModuleQualification from "./etqa/moderator/ModeratorModuleQualification";
import Moderatorlearnership from "./etqa/moderator/ModeratorLearnerships";
import ModeratorUnitStandards from "./etqa/moderator/ModeratorUnitStandards";
import ModeratorProviderSearch from "./etqa/moderator/ModeratorProviders";
import ModeratorRegistrationDetails from "./etqa/moderator/ModeratorRegistrationDetails";
import AssessorSkillsProgrammeSearch from "./etqa/assessor/AssessorSkillsProgramme";
import AssessorQualificationSearch from "./etqa/assessor/AssessorQualifications";
import AssessorModuleQualificationSearch from "./etqa/assessor/AssessorModuleQualifications";
import AssessorLearnershipSearch from "./etqa/assessor/AssessorLearnerships";
import AssessorLearnershipUSSearch from "./etqa/assessor/AssessorLearnershipUSSearch";
import ModeratorRegistrationHistory from "./etqa/moderator/RegistrationHistory";
import ModeratorCRM from "./etqa/moderator/ModeratorCRM";
import UploadPerson from "./etqa/bulkupload/uploadPerson";
import UploadLearnership from "./etqa/bulkupload/uploadLearnership";
import UploadSkills from "./etqa/bulkupload/uploadSkills";
import UploadBursaries from "./etqa/bulkupload/uploadBursaries";
import UploadInternship from "./etqa/bulkupload/uploadInternship";
import UploadAET from "./etqa/bulkupload/uploadAET";
import UploadCandidacy from "./etqa/bulkupload/uploadCandidacy";
import UploadWIL from "./etqa/bulkupload/uploadWIL";
import UploadFET from "./etqa/bulkupload/uploadFET";
import UploadQualification from "./etqa/bulkupload/uploadQualification";
import UploadUnitStandard from "./etqa/bulkupload/uploadUnitStandard";
import UploadEntrepreneurship from "./etqa/bulkupload/uploadEntrepreneurship";
import UploadRPL from "./etqa/bulkupload/uploadRPL";
import UploadShortCourse from "./etqa/bulkupload/uploadShortCourse";
import UploadMathsandScience from "./etqa/bulkupload/uploadMathsandScience";
import UploadWorkReadiness from "./etqa/bulkupload/uploadWorkReadiness";
import UploadAssistGrade12 from "./etqa/bulkupload/uploadAssistGrade12";
import UploadCapacityBuilding from "./etqa/bulkupload/uploadCapacityBuilding";
import UploadCareerGuidance from "./etqa/bulkupload/uploadCareerGuidance";
import UploadDigitalLiteracy from "./etqa/bulkupload/uploadDigitalLiteracy";
import UploadAchievement from "./etqa/bulkupload/uploadAchievement";
import AssessorRegistrationHistory from "./etqa/assessor/RegistrationHistory";
import LearnerSkillsProgram from "./etqa/learner/LearnerSkillsProgram";
import AddLearnerSkillsProgram from "./etqa/learner/AddLearnerSkillsProgram";
import AddLearnerEntrepreneurship from "./etqa/learner/AddLearnerEntrepreneurship";
import AddLearnerCapacityBuildingSupport from "./etqa/learner/AddLearnerCapacityBuildingSupport";
import AddLearnerSeniorCertificateAssistance from "./etqa/learner/AddLearnerSeniorCertificateAssistance";
import AddLearnerDigitalLiteracy from "./etqa/learner/AddLearnerDigitalLiteracy";
import AddLearnerCareerGuidanceWorkshop from "./etqa/learner/AddLearnerCareerGuidanceWorkshop";
import AddLearnerRPL from "./etqa/learner/AddLearnerRPL";
import AddLearnerShortCourse from "./etqa/learner/AddLearnerShortCourse";
import AddLearnerWIL from "./etqa/learner/AddLearnerWIL";
import AddLearnerMathScienceSupport from "./etqa/learner/AddLearnerMathScienceSupport";
import AddLearnerWorkReadinessProgramme from "./etqa/learner/AddLearnerWorkReadinessProgramme";
import AddLearnerBursary from "./etqa/learner/AddLearnerBursary";
import AddLearnerInternships from "./etqa/learner/AddLearnerInternships";
import AddLearnerLearnership from "./etqa/learner/AddLearnerLearnership";
import AddLearnerQualification from "./etqa/learner/AddLearnerQualification";
import AddLearnerModuleQualification from "./etqa/learner/AddLearnerModuleQualification";
import AddLearnerUnitStandard from "./etqa/learner/AddLearnerUnitStandard";
import AddLearnerAET from "./etqa/learner/AddLearnerAET";
import AddLearnerFET from "./etqa/learner/AddLearnerFET";
import AddLearnerCandidacy from "./etqa/learner/AddLearnerCandidacy";
import AddLearnerTrade from "./etqa/learner/AddLearnerTrade";
import AssessorUnitStandards from "./etqa/assessor/AssessorUnitStandards";
import AssessorProviderSearch from "./etqa/assessor/AssessorProvider";
import AssessorRegistrationDetails from "./etqa/assessor/AssessorRegistrationDetails";
import AssessorCRM from "./etqa/assessor/AssessorCRM";
import EmployerCRM from "./etqa/employer/EmployerCRM";
import CareerGuidanceWorkshopSearch from "./etqa/careerGuidance/CareerGuidanceWorkshopSearch";
import AddCareerGuidanceWorkshop from "./etqa/careerGuidance/AddCareerGuidanceWorkshop";

import OrganisationCRM from "./skills/organisation/OrganisationCRM";

import GrantSetupSearch from "./etqa/grants/grantsetup/GrantSetupSearch";
import AddEditTranche from "./etqa/grants/grantsetup/AddEditTranche";
import TrancheDetails from "./etqa/grants/grantsetup/TrancheDetails";
import ProcessingNav from "./etqa/grants/grantprocessing/ProcessingNav";
import GenerateClaimSearch from "./etqa/grants/grantprocessing/GenerateClaimSearch";
import ApproveClaimSearch from "./etqa/grants/grantprocessing/ApproveClaimSearch";
import GrantClaimFormReversalSearch from "./etqa/grants/grantprocessing/GrantClaimFormReversalSearch";
import DownloadClaimSearch from "./etqa/grants/grantprocessing/DownloadClaimSearch";
import GenerateBatchSearch from "./etqa/grants/grantprocessing/GenerateBatchSearch";
import DownloadBatchSearch from "./etqa/grants/grantprocessing/DownloadBatchSearch";
import AXProcessorSearch from "./etqa/grants/grantprocessing/AXProcessorSearch";
import GrantReversalsSearch from "./etqa/grants/grantprocessing/GrantReversalsSearch";
import BulkGrantAssociation from "./etqa/grants/grantassociations/BulkGrantAssociation";
import BulkGrantDeAssociation from "./etqa/grants/grantassociations/BulkGrantDiAssociation";

import ProviderCRM from "./etqa/provider/ProviderCRM";
import AssessorIDDocument from "./etqa/assessor/AssessorIDDocument";

import OnlineRegistrationTypeSelect from "./etqa/onlineRegistration/OnlineRegistrationTypeSelect";
import OnlineRegistrationSecondryTypeSelect from "./etqa/onlineRegistration/OnlineRegistrationSecondryTypeSelect";
import AddOnlineAssessorFlow from "./etqa/onlineRegistration/assessor/AddOnlineAssessorFlow";
import OnlineAssessorApprovalSearch from "./etqa/onlineRegistration/assessor/OnlineAssessorApprovalSearch";
import AssessorApproval from "./etqa/onlineRegistration/assessor/AssessorApproval";
import OnlineAssessorApprovalQualificationScope from "./etqa/onlineRegistration/assessor/OnlineAssessorApprovalQualificationScope";
import OnlineAssessorApprovalUnitStandardScope from "./etqa/onlineRegistration/assessor/OnlineAssessorApprovalUnitStandardScope";
import OnlineAssessorApprovalSkillsProgrammeScope from "./etqa/onlineRegistration/assessor/OnlineAssessorApprovalSkillsProgrammeScope";
import OnlineAssessorApprovalDocuments from "./etqa/onlineRegistration/assessor/OnlineAssessorApprovalDocuments";
import OnlineAssessorDetailsVerification from "./etqa/onlineRegistration/assessor/OnlineAssessorDetailsVerification";
import OnlineAssessorApprovalLearnershipScope from "./etqa/onlineRegistration/assessor/OnlineAssessorApprovalLearnershipScope";

import AddOnlineModeratorFlow from "./etqa/onlineRegistration/moderator/AddOnlineModeratorFlow";
import OnlineModeratorApprovalSearch from "./etqa/onlineRegistration/moderator/OnlineModeratorApprovalSearch";
import ModeratorApproval from "./etqa/onlineRegistration/moderator/ModeratorApproval";
import OnlineModeratorApprovalQualificationScope from "./etqa/onlineRegistration/moderator/OnlineModeratorApprovalQualificationScope";
import OnlineModeratorApprovalUnitStandardScope from "./etqa/onlineRegistration/moderator/OnlineModeratorApprovalUnitStandardScope";
import OnlineModeratorApprovalSkillsProgrammeScope from "./etqa/onlineRegistration/moderator/OnlineModeratorApprovalSkillsProgrammeScope";
import OnlineModeratorApprovalDocuments from "./etqa/onlineRegistration/moderator/OnlineModeratorApprovalDocuments";
import OnlineModeratorDetailsVerification from "./etqa/onlineRegistration/moderator/OnlineModeratorDetailsVerification";
import OnlineModeratorApprovalLearnershipScope from "./etqa/onlineRegistration/moderator/OnlineModeratorApprovalLearnershipScope";

import AddOnlineProviderFlow from "./etqa/onlineRegistration/provider/AddOnlineProviderFlow";
import OnlineProviderApprovalSearch from "./etqa/onlineRegistration/provider/OnlineProviderApprovalSearch";
import ProviderApproval from "./etqa/onlineRegistration/provider/ProviderApproval";
import OnlineProviderApprovalQualificationScope from "./etqa/onlineRegistration/provider/OnlineProviderApprovalQualificationScope";
import OnlineProviderApprovalUnitStandardScope from "./etqa/onlineRegistration/provider/OnlineProviderApprovalUnitStandardScope";
import OnlineProviderApprovalSkillsProgrammeScope from "./etqa/onlineRegistration/provider/OnlineProviderApprovalSkillsProgrammeScope";
import OnlineProviderApprovalDocuments from "./etqa/onlineRegistration/provider/OnlineProviderApprovalDocuments";
import OnlineProviderDetailsVerification from "./etqa/onlineRegistration/provider/OnlineProviderDetailsVerification";
import OnlineProviderApprovalLearnershipScope from "./etqa/onlineRegistration/provider/OnlineProviderApprovalLearnershipScope";

import ProviderSearch from "./etqa/provider/ProviderSearch";
import Provider from "./etqa/provider/Provider";
import Outcome from "./etqa/program/Outcome";
import ProviderMonitoringAndEvaluation from "./etqa/provider/ProviderMonitoringAndEvaluation";
import ProviderTrade from "./etqa/provider/ProviderTrade";
import ProviderContact from "./etqa/provider/ProviderContact";
import ProviderUsers from "./etqa/provider/ProviderUsers";
import ProviderSiteVisitsSearch from "./etqa/provider/ProviderSiteVisits";
import ProviderAccreditation from "./etqa/provider/ProviderAccreditation";
import ProviderAccreditationHistory from "./etqa/provider/ProviderAccreditationHistory";
import ProviderLearner from "./etqa/provider/ProviderLearner";
import ProviderUnitStandards from "./etqa/provider/ProviderUnitStandards";
import ProviderQualificationSearch from "./etqa/provider/ProviderQualificationsSearch";
import ProviderModuleQualificationsSearch from "./etqa/provider/ProviderModuleQualificationsSearch";
import ProviderSkillsProgrammeSearch from "./etqa/provider/ProviderSkillsProgrammeSearch";
import ProviderSkillsProgrammeUSSearch from "./etqa/provider/ProviderSkillsProgrammeUSSearch";
import ProviderLearnershipUSSearch from "./etqa/provider/ProviderLearnershipUSSearch";
import ProviderQualificationUSSearch from "./etqa/provider/ProviderQualificationUSSearch";
import ProviderLearnershipSearch from "./etqa/provider/ProviderLearnershipSearch";
import ProviderAssessorSearch from "./etqa/provider/ProviderAssessors";
import ProviderModeratorSearch from "./etqa/provider/ProviderModeratorSearch";
import ProviderLogoApplication from './etqa/provider/ProviderLogoApplication';
import ExternalProviderSearch from "./etqa/externalmoderator/ExternalModeratorSearch";
import UnitStandardSetupSearch from "./etqa/program/UnitStandardSetupSearch";
import UnitStandardSetup from "./etqa/program/UnitStandardSetup";
import ModuleSetupSearch from "./etqa/program/ModuleSetupSearch";
import ModuleSetup from "./etqa/program/ModuleSetup";
import QualificationSetupSearch from "./etqa/program/QualificationSetupSearch";
import QualificationSetup from "./etqa/program/QualificationSetup";
import LearnershipSetupSearch from "./etqa/program/LearnershipSetupSearch";
import AETSetupSearch from "./etqa/program/AET/AETSetupSearch";
import AETSetup from "./etqa/program/AET/AETSetup";
import TradeSetupSearch from "./etqa/program/Trade/TradeSetupSearch";
import TradeSetup from "./etqa/program/Trade/TradeSetup";
import LearnershipUnitStandardSearch from "./etqa/program/LearnershipUnitStandardSearch";
import LearnershipModuleSearch from "./etqa/program/LearnershipModuleSearch"; 
import LearnershipSetup from "./etqa/program/LearnershipSetup";
import SAQAXMLImport from "./etqa/program/SAQAXMLImport";
import ShortCourseSetupSearch from "./etqa/program/ShortCourseSetupSearch";
import SkillsProgramSetupSearch from "./etqa/program/SkillsProgramSetupSearch";
import SkillsProgramSetup from "./etqa/program/SkillsProgramSetup";
import ArtisansSetupSearch from "./etqa/program/ArtisansSetupSearch";
import EmployerLearnerSearch from "./etqa/employer/EmployerLearnerSearch";
import EmployerUserSearch from "./etqa/employer/EmployerUserSearch";
import EmployerContactSearch from "./etqa/employer/EmployerContactSearch";
import AddLearnerFlow from "./etqa/learner/AddLearnerFlow";
import AddPersonFlow from "./etqa/person/AddPersonFlow";
import AddAssessorFlow from "./etqa/assessor/AddAssessorFlow";
import AddModeratorFlow from "./etqa/moderator/AddModeratorFlow";
import Dashboard from "./widgets/Dashboard";
import SDFDashboard from "./Dashboards/SDFDashboard";
import StakeholderDashboard from "./Dashboards/StakeholderDashboard";
import SkillsDashboard from "./Dashboards/SkillsDashboard";
import { Route } from "react-router-dom";
import QualificationUnitStandardSearch from "./etqa/program/QualificationUnitStandardSearch";
import QualificationModuleSearch from "./etqa/program/QualificationModuleSearch";
import SkillsUnitStandardSearch from "./etqa/program/SkillsUnitStandardSearch";
import SDFSearch from "./skills/sdf/SDFSearch";
import RoleMaintenanceSearch from "./maintenance/Role/RoleSearch";
import UserMaintenanceSearch from "./maintenance/User/UserSearch";
import UserDetailsMaintenanceSearch from "./maintenance/User/UserDetail";

import UserRoleSearch from "./maintenance/User/UserRoles";
import ClientsEmailsSearch from "./maintenance/Clients/ClientsEmailsSearch";
import EmailAdd from "./maintenance/Clients/EmailAdd";

import SkillsLetterCreationSearch from "./maintenance/Skills/SkillsLetterCreationSearch";
import SkillsLetterCreation from "./maintenance/Skills/SkillsLetterCreation";
import SkillsQueryReasonSearch from "./maintenance/Skills/SkillsQueryReasonSearch";
import SkillsQueryReason from "./maintenance/Skills/SkillsQueryReason";
import SkillsRejectionReasonSearch from "./maintenance/Skills/SkillsRejectionReasonSearch";
import SkillsRejectionReason from "./maintenance/Skills/SkillsRejectionReason";
import SkillsTNumberConversionSearch from "./maintenance/Skills/SkillsTNumberConversionSearch";
import SkillsTNumberConversion from "./maintenance/Skills/SkillsTNumberConversion";

import CreateBenefitsDescriptionSearch from "./maintenance/Benefits/CreateBenefitsDescriptionSearch";
import BenefitsDescriptionsSearch from "./maintenance/Benefits/BenefitsDescriptionsSearch";
import CreateInterventionTitles from "./maintenance/Benefits/CreateInterventionTitles";
import BenefitsTargetAddFormSearch from "./maintenance/Benefits/BenefitsTargetAddFormSearch";
import BenefitsTargetsSearch from "./maintenance/Benefits/BenefitsTargetsSearch";
import InterventionTitlesSearch from "./maintenance/Benefits/InterventionTitlesSearch";

import LinkingSearch from "./maintenance/Benefits/LinkingSearch";
import BenefitsUpload from "./maintenance/Benefits/BenefitsUpload";
import CreateLinkingSearch from "./maintenance/Benefits/CreateLinkingSearch";

import DGLetterCreation from "./maintenance/DG/DGLetterCreation";
import DGLetterCreationSearch from "./maintenance/DG/DGLetterCreationSearch";
import DGQueryReasonSearch from "./maintenance/DG/DGQueryReasonSearch";
import DGQueryReason from "./maintenance/DG/DGQueryReason";
import DGRejectionReasonSearch from "./maintenance/DG/DGRejectionReasonSearch";
import DGRejectionReason from "./maintenance/DG/DGRejectionReason";

import Role from "./maintenance/Role/Role";
import RolePermissionSearch from "./maintenance/Role/RolePermissionSearch";
import RolePermission from "./maintenance/Role/RolePermission";
import SDF from "./skills/sdf/SDF";
import SDFOrganisationDetails from "./skills/sdf/SDFOrganisations";

import DGOrganisationSearch from "./dg/organisation/DGOrganisationSearch";
import DGOrganisation from "./dg/organisation/DGOrganisation";
import StakeholderSearch from "./dg/stakeholder/StakeholderSearch";
import Stakeholder from "./dg/stakeholder/Stakeholder";
import StakeholderOrganisationDetails from "./dg/stakeholder/StakeholderOrganisationDetails";
import DGOrganisationContact from "./dg/organisation/DGOrganisationContact";
import DGDocumentsUpload from "./dg/documentuploads/DGDocumentUploads";
import OrganisationStakeholder from "./dg/organisation/OrganisationStakeholder";
import DGOrganisationCRM from "./dg/organisation/DGOrganisationCRM";

import Organisation from "./skills/organisation/Organisation";
import OrganisationSearch from "./skills/organisation/OrganisationSearch";
import OrganisationContact from "./skills/organisation/OrganisationContact";
import OrganisationBankingDetails from "./skills/organisation/OrganisationBankingDetails";
import ChildOrganisationSearch from "./skills/organisation/ChildOrganisationSearch";
import ChildOrganisation from "./skills/organisation/ChildOrganisation";
import OrganisationCFODetails from "./skills/organisation/OrganisationCFODetails";
import TrainingCommitteeSearchRecord from "./skills/organisation/TrainingCommitteeRecords";
import TrainingCommittee from "./skills/organisation/TrainingCommittee";
import UnionSearchRecord from "./skills/organisation/UnionRecords";

import WspAtrForms from "./skills/WspAtrForms/WspAtrForms";
import HardToFillVacanciesForm2023 from "./skills/WspAtrForms/Forms/2023/HardToFillVacancies";
import CommonSkillsGapsForm2023 from "./skills/WspAtrForms/Forms/2023/CommonSkillsGaps";
import EmploymentProfileForm2023 from "./skills/WspAtrForms/Forms/2023/EmploymentProfile";
import PlannedBeneficiariesEmployedForm2023 from "./skills/WspAtrForms/Forms/2023/PlannedBeneficiariesEmployed";
import PlannedBeneficiariesUnemployedForm2023 from "./skills/WspAtrForms/Forms/2023/PlannedBeneficiariesUnemployed";
import PlannedAETForm2023 from "./skills/WspAtrForms/Forms/2023/PlannedAET";
import HighestEducationProfileForm2023 from "./skills/WspAtrForms/Forms/2023/HighestEducationProfile";
import TrainingReportSummaryForm2023 from "./skills/WspAtrForms/Forms/2023/TrainingReportSummary";
import TrainingReportEmployedForm2023 from "./skills/WspAtrForms/Forms/2023/TrainingReportEmployed";
import TrainingReportUnemployedForm2023 from "./skills/WspAtrForms/Forms/2023/TrainingReportUnemployed";
import CompletedAETForm2023 from "./skills/WspAtrForms/Forms/2023/CompletedAET";
import EmploymentProfileSmallForm2023 from "./skills/WspAtrForms/Forms/2023/EmploymentProfileSmall";

import HardToFillVacanciesForm2024 from "./skills/WspAtrForms/Forms/2024/HardToFillVacancies";
import CommonSkillsGapsForm2024 from "./skills/WspAtrForms/Forms/2024/CommonSkillsGaps";
import EmploymentProfileForm2024 from "./skills/WspAtrForms/Forms/2024/EmploymentProfile";
import PlannedBeneficiariesEmployedForm2024 from "./skills/WspAtrForms/Forms/2024/PlannedBeneficiariesEmployed";
import PlannedBeneficiariesUnemployedForm2024 from "./skills/WspAtrForms/Forms/2024/PlannedBeneficiariesUnemployed";
import PlannedAETForm2024 from "./skills/WspAtrForms/Forms/2024/PlannedAET";
import HighestEducationProfileForm2024 from "./skills/WspAtrForms/Forms/2024/HighestEducationProfile";
import TrainingReportSummaryForm2024 from "./skills/WspAtrForms/Forms/2024/TrainingReportSummary";
import TrainingReportEmployedForm2024 from "./skills/WspAtrForms/Forms/2024/TrainingReportEmployed";
import TrainingReportUnemployedForm2024 from "./skills/WspAtrForms/Forms/2024/TrainingReportUnemployed";
import CompletedAETForm2024 from "./skills/WspAtrForms/Forms/2024/CompletedAET";
import EmploymentProfileSmallForm2024 from "./skills/WspAtrForms/Forms/2024/EmploymentProfileSmall";
import ProvincialDetailsForm2024 from "./skills/WspAtrForms/Forms/2024/ProvincialDetails";

import HardToFillVacanciesForm2025 from "./skills/WspAtrForms/Forms/2025/HardToFillVacancies";
import CommonSkillsGapsForm2025 from "./skills/WspAtrForms/Forms/2025/CommonSkillsGaps";
import EmploymentProfileForm2025 from "./skills/WspAtrForms/Forms/2025/EmploymentProfile";
import PlannedBeneficiariesEmployedForm2025 from "./skills/WspAtrForms/Forms/2025/PlannedBeneficiariesEmployed";
import PlannedBeneficiariesUnemployedForm2025 from "./skills/WspAtrForms/Forms/2025/PlannedBeneficiariesUnemployed";
import PlannedAETForm2025 from "./skills/WspAtrForms/Forms/2025/PlannedAET";
import HighestEducationProfileForm2025 from "./skills/WspAtrForms/Forms/2025/HighestEducationProfile";
import TrainingReportSummaryForm2025 from "./skills/WspAtrForms/Forms/2025/TrainingReportSummary";
import TrainingReportEmployedForm2025 from "./skills/WspAtrForms/Forms/2025/TrainingReportEmployed";
import TrainingReportUnemployedForm2025 from "./skills/WspAtrForms/Forms/2025/TrainingReportUnemployed";
import CompletedAETForm2025 from "./skills/WspAtrForms/Forms/2025/CompletedAET";
import EmploymentProfileSmallForm2025 from "./skills/WspAtrForms/Forms/2025/EmploymentProfileSmall";
import ProvincialDetailsForm2025 from "./skills/WspAtrForms/Forms/2025/ProvincialDetails";

import HardToFillVacanciesForm2026 from "./skills/WspAtrForms/Forms/2026/HardToFillVacancies";
import CommonSkillsGapsForm2026 from "./skills/WspAtrForms/Forms/2026/CommonSkillsGaps";
import EmploymentProfileForm2026 from "./skills/WspAtrForms/Forms/2026/EmploymentProfile";
import PlannedBeneficiariesEmployedForm2026 from "./skills/WspAtrForms/Forms/2026/PlannedBeneficiariesEmployed";
import PlannedBeneficiariesUnemployedForm2026 from "./skills/WspAtrForms/Forms/2026/PlannedBeneficiariesUnemployed";
import PlannedAETForm2026 from "./skills/WspAtrForms/Forms/2026/PlannedAET";
import HighestEducationProfileForm2026 from "./skills/WspAtrForms/Forms/2026/HighestEducationProfile";
import TrainingReportSummaryForm2026 from "./skills/WspAtrForms/Forms/2026/TrainingReportSummary";
import TrainingReportEmployedForm2026 from "./skills/WspAtrForms/Forms/2026/TrainingReportEmployed";
import TrainingReportUnemployedForm2026 from "./skills/WspAtrForms/Forms/2026/TrainingReportUnemployed";
import CompletedAETForm2026 from "./skills/WspAtrForms/Forms/2026/CompletedAET";
import EmploymentProfileSmallForm2026 from "./skills/WspAtrForms/Forms/2026/EmploymentProfileSmall";
import ProvincialDetailsForm2026 from "./skills/WspAtrForms/Forms/2026/ProvincialDetails";

import WspAtrDashboard from "./skills/WspAtrForms/WspAtrDashboard";
import WspAtrDocumentsUpload from "./skills/WspAtrForms/DocumentsUpload";
import WspAtrVerification from "./skills/WspAtrForms/WSPATRVerificationSearch";
import WSPATRVerificationMain from "./skills/WspAtrForms/WSPATRVerificationMain";
import WSPATREvaluation from "./skills/WspAtrForms/WSPATREvaluationSearch";
import WSPATREvaluationMain from "./skills/WspAtrForms/WSPATREvaluationMain";
import Approval from "./skills/WspAtrForms/Approval";
import WspAtrApproval from "./skills/WspAtrForms/WSPATRApprovalSearch";
import WSPATRApprovalMain from "./skills/WspAtrForms/WSPATRApprovalMain";
import Verification from "./skills/WspAtrForms/Verification";
import Evaluation from "./skills/WspAtrForms/Evaluation";
import Feedback from "./skills/organisation/Stackholderfeedback";
import RequestExtension from "./skills/WspAtrForms/Extension";
import LodgeApeal from "./skills/WspAtrForms/LodgeApeal";

import OrganisationSDF from "./skills/organisation/OrganisationSDF";
import OrganisationGrantsLevies from "./skills/organisation/OrganisationGrantsLevies";
import Levies from "./skills/organisation/Levies";
import Grants from "./skills/organisation/Grants";
import DiscretionaryGrants from "./skills/organisation/DiscretionaryGrants";
import InterSetaTransfer from "./skills/organisation/InterSetaTransfer";
import SDFComplianceLetter from "./skills/organisation/OrganisationSDFComplianceLetter";

import EmployerFileImport from "./skills/EmployerFileImport/EmployerFileImport";

import ETQAReportSearch from "./reports/etqa/ETQAReportSearch";
import ETQAReport from "./reports/etqa/ETQAReport";
import SkillsReportSearch from "./reports/skills/SkillsReportSearch";
import SkillsReport from "./reports/skills/SkillsReport";
import MasterFileSearch from "./reports/masterfiles/MasterFileSearch";
import MasterFile from "./reports/masterfiles/MasterFile";
import SETMISFileSearch from "./reports/setmisfiles/SETMISFileSearch";
import SETMISFile from "./reports/setmisfiles/SETMISFile";
import DGReportSearch from "./reports/dg/DGReportSearch";
import DGReport from "./reports/dg/DGReport";
import CustomReports from "./reports/customreports/CustomReports";
import CustomReportsV2 from "./reports/customreports/CustomReportsV2";
import AdminReportSearch from "./reports/admin/AdminReportSearch";
import AdminReport from "./reports/admin/AdminReport";
import ProviderReportSearch from "./reports/provider/ProviderReportSearch";
import ProviderReport from "./reports/provider/ProviderReport";
import EmployerReportSearch from "./reports/employer/EmployerReportSearch";
import EmployerReport from "./reports/employer/EmployerReport";

import ProviderDocuments from "./etqa/approval and certification/ProviderDocuments";
import AssessorDocuments from "./etqa/approval and certification/AssessorDocuments";
import ModeratorDocuments from "./etqa/approval and certification/ModeratorDocuments";
import LearnerDocuments from "./etqa/approval and certification/LearnerDocuments";
import BulkApproval from "./etqa/approval and certification/BulkApproval";
import ExpiryNotification from "./etqa/expiry notification/ExpiryNotification";
import LearnerEndorsementLetter from "./etqa/approval and certification/LearnerEndorsementLetter";
import POR from "./etqa/proof of registration/ProofOfRegistrationSearch";

import Test from "./Test";
import TestTableDemo from "./test components/TestTableDemo";

import DGApplication from "./dg/application/DGApplication";
import DGApplicationDashboard from "./dg/application/DGApplicationDashboard";
import DGForms from "./dg/application/Forms/DGForms";
import DGVerificationSearch from "./dg/verification/DGVerificationSearch";
import DGVerificationMain from "./dg/verification/DGVerificationMain";
import DGEvaluationSearch from "./dg/evaluation/DGEvaluationSearch";
import DGEvaluationMain from "./dg/evaluation/DGEvaluationMain";
import DGApprovalSearch from "./dg/approval/DGApprovalSearch";
import DGApprovalMain from "./dg/approval/DGApprovalMain";
import DGContracts from "./dg/contracts/DGContracts";

//DG Forms 2022
import ArtisanForm2022 from "./dg/application/Forms/2022/Artisan";
import AETForm2022 from "./dg/application/Forms/2022/AET";
import BursaryForm2022 from "./dg/application/Forms/2022/Bursary";
import LearnershipForm2022 from "./dg/application/Forms/2022/Learnership";
import CandidacyForm2022 from "./dg/application/Forms/2022/Candidacy";
import TVETForm2022 from "./dg/application/Forms/2022/TVET";
import LearnershipRPLForm2022 from "./dg/application/Forms/2022/LearnershipRPL";
import InternshipForm2022 from "./dg/application/Forms/2022/Internship";
import SkillsProgrammeForm2022 from "./dg/application/Forms/2022/SkillsProgramme";
import SkillsProgrammeEUForm2022 from "./dg/application/Forms/2022/SkillsProgrammeEU";
import WorkExperienceForm2022 from "./dg/application/Forms/2022/WorkExperience";

//DG Forms 2023
import AETForm2023 from "./dg/application/Forms/2023/AET";
import CandidacyForm2023 from "./dg/application/Forms/2023/Candidacy";
import InternshipForm2023 from "./dg/application/Forms/2023/Internship";
import SkillsProgrammeForm2023 from "./dg/application/Forms/2023/SkillsProgramme";
import LearnershipForm2023 from "./dg/application/Forms/2023/Learnership";
import EntrepreneurshipProgrammeForm2023 from "./dg/application/Forms/2023/EntrepreneurshipProgramme";
import RPLForm2023 from "./dg/application/Forms/2023/RPL";
import BursaryForm2023 from "./dg/application/Forms/2023/Bursary";
import ShortCourseForm2023 from "./dg/application/Forms/2023/ShortCourse";
import WILForm2023 from "./dg/application/Forms/2023/WIL";
import MathScienceForm2023 from "./dg/application/Forms/2023/MathScience";
import WorkReadinessProgrammeForm2023 from "./dg/application/Forms/2023/WorkReadinessProgramme";
import AssistLearnersNotPassedForm2023 from "./dg/application/Forms/2023/AssistLearnersNotPassed";
import CapacityBuildingSupportForm2023 from "./dg/application/Forms/2023/CapacityBuildingSupport";
import CareerGuidanceWorkshopForm2023 from "./dg/application/Forms/2023/CareerGuidanceWorkshop";
import DigitalLiteracyProgrammeForm2023 from "./dg/application/Forms/2023/DigitalLiteracyProgramme";
import QualificationForm2023 from "./dg/application/Forms/2023/Qualification";

//DG Forms 2024
import AETForm2024 from "./dg/application/Forms/2024/AET";
import CandidacyForm2024 from "./dg/application/Forms/2024/Candidacy";
import InternshipForm2024 from "./dg/application/Forms/2024/Internship";
import SkillsProgrammeForm2024 from "./dg/application/Forms/2024/SkillsProgramme";
import LearnershipForm2024 from "./dg/application/Forms/2024/Learnership";
import EntrepreneurshipProgrammeForm2024 from "./dg/application/Forms/2024/EntrepreneurshipProgramme";
import RPLForm2024 from "./dg/application/Forms/2024/RPL";
import BursaryForm2024 from "./dg/application/Forms/2024/Bursary";
import ShortCourseForm2024 from "./dg/application/Forms/2024/ShortCourse";
import WILForm2024 from "./dg/application/Forms/2024/WIL";
import MathScienceForm2024 from "./dg/application/Forms/2024/MathScience";
import WorkReadinessProgrammeForm2024 from "./dg/application/Forms/2024/WorkReadinessProgramme";
import AssistLearnersNotPassedForm2024 from "./dg/application/Forms/2024/AssistLearnersNotPassed";
import CapacityBuildingSupportForm2024 from "./dg/application/Forms/2024/CapacityBuildingSupport";
import CareerGuidanceWorkshopForm2024 from "./dg/application/Forms/2024/CareerGuidanceWorkshop";
import DigitalLiteracyProgrammeForm2024 from "./dg/application/Forms/2024/DigitalLiteracyProgramme";
import QualificationForm2024 from "./dg/application/Forms/2024/Qualification";

//Helpdesk
import HelpdeskRequestSearch from "./helpdesk/Request/HelpdeskRequestSearch";
import HelpdeskRequest from "./helpdesk/Request/HelpdeskRequest";
import HelpDeskReport from "./helpdesk/Report/HelpDeskReport";

import AudienceOptions from "./maintenance/CRM/AudienceOptions";

import QALPDashboard from "./Dashboards/QALPDashboard";
import MGDashboard from "./Dashboards/MGDashboard";
import DGDashboard from "./Dashboards/DGDashboard";

import IDVerificationPortal from "./etqa/IDVerificationPortal/IDVerificationPortal";
import SkillsProgrammeModuleSearch from "./etqa/program/SkillsProgrammeModuleSearch";

//DG Forms 2025
import AETForm2025 from "./dg/application/Forms/2025/AET";
import CandidacyForm2025 from "./dg/application/Forms/2025/Candidacy";
import InternshipForm2025 from "./dg/application/Forms/2025/Internship";
import SkillsProgrammeForm2025 from "./dg/application/Forms/2025/SkillsProgramme";
import LearnershipForm2025 from "./dg/application/Forms/2025/Learnership";
import EntrepreneurshipProgrammeForm2025 from "./dg/application/Forms/2025/EntrepreneurshipProgramme";
import RPLForm2025 from "./dg/application/Forms/2025/RPL";
import BursaryForm2025 from "./dg/application/Forms/2025/Bursary";
import ShortCourseForm2025 from "./dg/application/Forms/2025/ShortCourse";
import WILForm2025 from "./dg/application/Forms/2025/WIL";
import MathScienceForm2025 from "./dg/application/Forms/2025/MathScience";
import WorkReadinessProgrammeForm2025 from "./dg/application/Forms/2025/WorkReadinessProgramme";
import AssistLearnersNotPassedForm2025 from "./dg/application/Forms/2025/AssistLearnersNotPassed";
import CapacityBuildingSupportForm2025 from "./dg/application/Forms/2025/CapacityBuildingSupport";
import CareerGuidanceWorkshopForm2025 from "./dg/application/Forms/2025/CareerGuidanceWorkshop";
import DigitalLiteracyProgrammeForm2025 from "./dg/application/Forms/2025/DigitalLiteracyProgramme";
import QualificationForm2025 from "./dg/application/Forms/2025/Qualification";

//DG Forms 2026
import AETForm2026 from "./dg/application/Forms/2026/AET";
import CandidacyForm2026 from "./dg/application/Forms/2026/Candidacy";
import InternshipForm2026 from "./dg/application/Forms/2026/Internship";
import SkillsProgrammeForm2026 from "./dg/application/Forms/2026/SkillsProgramme";
import LearnershipForm2026 from "./dg/application/Forms/2026/Learnership";
import EntrepreneurshipProgrammeForm2026 from "./dg/application/Forms/2026/EntrepreneurshipProgramme";
import RPLForm2026 from "./dg/application/Forms/2026/RPL";
import BursaryForm2026 from "./dg/application/Forms/2026/Bursary";
import ShortCourseForm2026 from "./dg/application/Forms/2026/ShortCourse";
import WILForm2026 from "./dg/application/Forms/2026/WIL";
import MathScienceForm2026 from "./dg/application/Forms/2026/MathScience";
import WorkReadinessProgrammeForm2026 from "./dg/application/Forms/2026/WorkReadinessProgramme";
import AssistLearnersNotPassedForm2026 from "./dg/application/Forms/2026/AssistLearnersNotPassed";
import CapacityBuildingSupportForm2026 from "./dg/application/Forms/2026/CapacityBuildingSupport";
import CareerGuidanceWorkshopForm2026 from "./dg/application/Forms/2026/CareerGuidanceWorkshop";
import DigitalLiteracyProgrammeForm2026 from "./dg/application/Forms/2026/DigitalLiteracyProgramme";
import QualificationForm2026 from "./dg/application/Forms/2026/Qualification";

class Routes extends Component {
    render() {
        return (
            <span>
                <Route path='/dashboard' component={Dashboard} />
                <Route path='/sdfdashboard' component={SDFDashboard} />
                <Route path='/stakeholderdashboard' component={StakeholderDashboard} />
                <Route path='/skillsdashboard' component={SkillsDashboard} />
                <Route path='/employers' component={EmployerSearch} />
                <Route path='/employer' component={Employer} />
                <Route path='/employerLearners' component={EmployerLearnerSearch} />
                <Route path='/employerUsers' component={EmployerUserSearch} />
                <Route path='/employerContacts' component={EmployerContactSearch} />
                <Route path='/learners' component={LearnerSearch} />
                <Route path='/learner' component={Learner} />
                <Route path='/addLearnerSkillsProgram' component={AddLearnerSkillsProgram} />
                <Route path='/addLearnerEntrepreneurship' component={AddLearnerEntrepreneurship} />
                <Route path='/addLearnerCapacityBuildingSupport' component={AddLearnerCapacityBuildingSupport} />
                <Route path='/addLearnerSeniorCertificateAssistance' component={AddLearnerSeniorCertificateAssistance} />
                <Route path='/addLearnerDigitalLiteracy' component={AddLearnerDigitalLiteracy} />
                <Route path='/addLearnerCareerGuidanceWorkshop' component={AddLearnerCareerGuidanceWorkshop} />
                <Route path='/addLearnerRPL' component={AddLearnerRPL} />
                <Route path='/addLearnerShortCourse' component={AddLearnerShortCourse} />
                <Route path='/addLearnerWIL' component={AddLearnerWIL} />
                <Route path='/addLearnerMathScienceSupport' component={AddLearnerMathScienceSupport} />
                <Route path='/addLearnerWorkReadinessProgramme' component={AddLearnerWorkReadinessProgramme} />
                <Route path='/addLearnerBursary' component={AddLearnerBursary} />
                <Route path='/addLearnerInternships' component={AddLearnerInternships} />
                <Route path='/addLearnerLearnership' component={AddLearnerLearnership} />
                <Route path='/addLearnerQualification' component={AddLearnerQualification} />
                <Route path='/LearnerQualificationUSSearch' component={LearnerQualificationUSSearch} />
                <Route path='/addLearnerModuleQualification' component={AddLearnerModuleQualification} />
                <Route path='/LearnerModuleQualificationUSSearch' component={LearnerModuleQualificationUSSearch} />
                <Route path='/addLearnerUnitStandard' component={AddLearnerUnitStandard} />
                <Route path='/addLearnerTrade' component={AddLearnerTrade} />
                <Route path='/addLearnerAET' component={AddLearnerAET} />
                <Route path='/addLearnerFET' component={AddLearnerFET} />
                <Route path='/addLearnerCandidacy' component={AddLearnerCandidacy} />
                <Route path='/LearnerSkillsProgrammeSearch' component={LearnerSkillsProgrammeSearch} />
                <Route path='/LearnerEntrepreneurshipSearch' component={LearnerEntrepreneurshipSearch} />
                <Route path='/LearnerCapacityBuildingSupportSearch' component={LearnerCapacityBuildingSupportSearch} />
                <Route path='/LearnerSeniorCertificateAssistanceSearch' component={LearnerSeniorCertificateAssistanceSearch} />
                <Route path='/LearnerDigitalLiteracySearch' component={LearnerDigitalLiteracySearch} />
                <Route path='/LearnerCareerGuidanceWorkshopSearch' component={LearnerCareerGuidanceWorkshopSearch} />
                <Route path='/LearnerRPLSearch' component={LearnerRPLSearch} />
                <Route path='/LearnerShortCourseSearch' component={LearnerShortCourseSearch} />
                <Route path='/LearnerWILSearch' component={LearnerWILSearch} />
                <Route path='/LearnerMathScienceSupportSearch' component={LearnerMathScienceSupportSearch} />
                <Route path='/LearnerWorkReadinessProgrammeSearch' component={LearnerWorkReadinessProgrammeSearch} />
                <Route path='/LearnerBursarySearch' component={LearnerBursarySearch} />
                <Route path='/LearnerAETSearch' component={LearnerAETSearch} />
                <Route path='/LearnerFETSearch' component={LearnerFETSearch} />
                <Route path='/LearnerLearnershipSearch' component={LearnerLearnershipSearch} />
                <Route path='/LearnerTradeSearch' component={LearnerTradeSearch} />
                <Route path='/learnerTradeTestSearch' component={LearnerTradeTestSearch} />
                <Route path='/LearnerInternshipsSearch' component={LearnerInternshipsSearch} />
                <Route path='/LearnerQualificationSearch' component={LearnerQualificationSearch} />
                <Route path='/LearnerModuleQualificationSearch' component={LearnerModuleQualificationSearch} />
                <Route path='/LearnerCandidacySearch' component={LearnerCandidacySearch} />
                <Route path='/LearnerUnitStandardSearch' component={LearnerUnitStandardSearch} />
                <Route path='/LearnerLearnershipAchievements' component={LearnerLearnershipAchievements} />
                <Route path='/ViewLearnershipAssessment' component={ViewLearnershipAssessment} />
                <Route path='/ViewQCTOLearnershipAssessment' component={ViewQCTOLearnershipAssessment} />
                <Route path='/ViewSkillsProgrammeAssessment' component={ViewSkillsProgrammeAssessment} />
                <Route path='/ViewQCTOSkillsProgrammeAssessment' component={ViewQCTOSkillsProgrammeAssessment} />
                <Route path='/ViewQualificationAssessment' component={ViewQualificationAssessment} />
                <Route path='/ViewModuleQualificationAssessment' component={ViewModuleQualificationAssessment} />
                <Route path='/ViewQCTOQualificationAssessment' component={ViewQCTOQualificationAssessment} />
                <Route path='/ViewUnitStandardAssessment' component={ViewUnitStandardAssessment} />
                <Route path='/LearnerUnitStandardAssessment' component={LearnerUnitStandardAssessment} />
                <Route path='/LearnerSkillsProgrammeAssessment' component={LearnerSkillsProgrammeAssessment} />
                <Route path='/LearnerQCTOSkillsProgrammeAssessment' component={LearnerQCTOSkillsProgrammeAssessment} />
                <Route path='/LearnerQualificationAssessment' component={LearnerQualificationAssessment} />
                <Route path='/LearnerModuleQualificationAssessment' component={LearnerModuleQualificationAssessment} />
                <Route path='/LearnerQCTOQualificationAssessment' component={LearnerQCTOQualificationAssessment} />
                <Route path='/LearnerLearnershipAssessments' component={LearnerLearnershipAssessments} />
                <Route path='/LearnerQCTOLearnershipAssessment' component={LearnerQCTOLearnershipAssessments} />
                <Route path='/ViewSkillsProgrammeAchievementUS' component={ViewSkillsProgrammeAchievementUS} />
                <Route path='/ViewLearnershipAchievementUS' component={ViewLearnershipAchievementUS} />
                <Route path='/ViewQualificationAchievementUS' component={ViewQualificationAchievementUS} />
                <Route path='/LearnerUnitStandardAchievements' component={LearnerUnitStandardAchievement} />
                <Route path='/LearnerQualificationAchievements' component={LearnerQualificationAchievement} />
                <Route path='/LearnerSkillsProgrammeAchievements' component={LearnerSkillsProgrammeAchievement} />
                <Route path='/learnerCRM' component={LearnerCRM} />
                <Route path='/persons' component={PersonSearch} />
                <Route path='/person' component={Person} />
                <Route path='/learnergrants' component={LearnerProgrammeGrants} />
                <Route path='/learnerTracking' component={LearnerTrackingSearch} />

                <Route path='/clientSearch' component={ClientsEmailsSearch} />

                <Route path='/moderatorSearch' component={ModeratorSearch} />
                <Route path='/Moderatorlearnership' component={Moderatorlearnership} />
                <Route path='/ModeratorSkillsProgramme' component={ModeratorSkillsProgramme} />
                <Route path='/moderatorQualification' component={ModeratorQualification} />
                <Route path='/moderatorModuleQualification' component={ModeratorModuleQualification} />
                <Route path='/moderatorUnitStandard' component={ModeratorUnitStandards} />
                <Route path='/moderatorProviderSearch' component={ModeratorProviderSearch} />
                <Route path='/moderatorCRM' component={ModeratorCRM} />
                <Route path='/uploadPerson' component={UploadPerson} />
                <Route path='/uploadLearnership' component={UploadLearnership} />
                <Route path='/uploadSkills' component={UploadSkills} />
                <Route path='/uploadBursaries' component={UploadBursaries} />
                <Route path='/uploadInternship' component={UploadInternship} />
                <Route path='/uploadAET' component={UploadAET} />
                <Route path='/uploadCandidacy' component={UploadCandidacy} />
                <Route path='/uploadWIL' component={UploadWIL} />
                <Route path='/uploadFET' component={UploadFET} />
                <Route path='/uploadQualification' component={UploadQualification} />
                <Route path='/uploadUnitStandard' component={UploadUnitStandard} />
                <Route path='/uploadEntrepreneurship' component={UploadEntrepreneurship} />
                <Route path='/uploadRPL' component={UploadRPL} />
                <Route path='/uploadShortCourse' component={UploadShortCourse} />
                <Route path='/uploadMandS' component={UploadMathsandScience} />
                <Route path='/uploadWorkReadiness' component={UploadWorkReadiness} />
                <Route path='/uploadAssistGrade12' component={UploadAssistGrade12} />
                <Route path='/uploadCapacityBuilding' component={UploadCapacityBuilding} />
                <Route path='/uploadCareerGuidance' component={UploadCareerGuidance} />
                <Route path='/uploadDigitalLiteracy' component={UploadDigitalLiteracy} />
                <Route path='/uploadAchievement' component={UploadAchievement} />
                <Route path='/EmployerCRM' component={EmployerCRM} />
                <Route path='/CareerGuidanceWorkshopSearch' component={CareerGuidanceWorkshopSearch} />
                <Route path='/AddCareerGuidanceWorkshop' component={AddCareerGuidanceWorkshop} />

                <Route path='/OrganisationCRM' component={OrganisationCRM} />

                <Route path='/providerCRM' component={ProviderCRM} />

                <Route path='/AssessorSkillsProgrammeSearch' component={AssessorSkillsProgrammeSearch} />
                <Route path='/AssessorQualificationSearch' component={AssessorQualificationSearch} />
                <Route path='/AssessorModuleQualificationSearch' component={AssessorModuleQualificationSearch} />
                <Route path='/AssessorRegistrationHistory' component={AssessorRegistrationHistory} />
                <Route path='/assessorLearnershipUnitStandards' component={AssessorLearnershipUSSearch} />
                <Route path='/Assessorlearnerships' component={AssessorLearnershipSearch} />
                <Route path='/moderatorRegistrationHistory' component={ModeratorRegistrationHistory} />
                <Route path='/AssessorUnitStandard' component={AssessorUnitStandards} />
                <Route path='/AssessorProviderSearch' component={AssessorProviderSearch} />
                <Route path='/AssessorRegistrationDetails' component={AssessorRegistrationDetails} />
                <Route path='/assessorCRM' component={AssessorCRM} />
                <Route path='/assessorIDDocument' component={AssessorIDDocument} />
                <Route path='/DGLetterCreationSearch' component={DGLetterCreationSearch} />
                <Route path='/DGLetterCreation' component={DGLetterCreation} />
                <Route path='/DGQueryReasonSearch' component={DGQueryReasonSearch} />
                <Route path='/DGQueryReason' component={DGQueryReason} />
                <Route path='/DGRejectionReasonSearch' component={DGRejectionReasonSearch} />
                <Route path='/DGRejectionReason' component={DGRejectionReason} />
                <Route path='/OnlineRegistrationTypeSelect' component={OnlineRegistrationTypeSelect} />
                <Route path='/OnlineRegistrationSecondryTypeSelect' component={OnlineRegistrationSecondryTypeSelect} />
                <Route path='/AddOnlineAssessorFlow' component={AddOnlineAssessorFlow} />
                <Route path='/OnlineAssessorApprovalSearch' component={OnlineAssessorApprovalSearch} />
                <Route path='/assessorapproval' component={AssessorApproval} />
                <Route path='/OnlineAssessorApprovalQualificationScope' component={OnlineAssessorApprovalQualificationScope} />
                <Route path='/OnlineAssessorApprovalUnitStandardScope' component={OnlineAssessorApprovalUnitStandardScope} />
                <Route path='/OnlineAssessorApprovalSkillsProgrammeScope' component={OnlineAssessorApprovalSkillsProgrammeScope} />
                <Route path='/OnlineAssessorApprovalLearnershipScope' component={OnlineAssessorApprovalLearnershipScope} />
                <Route path='/OnlineAssessorApprovalDocuments' component={OnlineAssessorApprovalDocuments} />
                <Route path='/OnlineAssessorDetailsVerification' component={OnlineAssessorDetailsVerification} />
                <Route path='/AddOnlineModeratorFlow' component={AddOnlineModeratorFlow} />
                <Route path='/OnlineModeratorApprovalSearch' component={OnlineModeratorApprovalSearch} />
                <Route path='/moderatorapproval' component={ModeratorApproval} />
                <Route path='/OnlineModeratorApprovalQualificationScope' component={OnlineModeratorApprovalQualificationScope} />
                <Route path='/OnlineModeratorApprovalUnitStandardScope' component={OnlineModeratorApprovalUnitStandardScope} />
                <Route path='/OnlineModeratorApprovalSkillsProgrammeScope' component={OnlineModeratorApprovalSkillsProgrammeScope} />
                <Route path='/OnlineModeratorApprovalLearnershipScope' component={OnlineModeratorApprovalLearnershipScope} />
                <Route path='/OnlineModeratorApprovalDocuments' component={OnlineModeratorApprovalDocuments} />
                <Route path='/OnlineModeratorDetailsVerification' component={OnlineModeratorDetailsVerification} />

                <Route path='/AddOnlineProviderFlow' component={AddOnlineProviderFlow} />
                <Route path='/OnlineProviderApprovalSearch' component={OnlineProviderApprovalSearch} />
                <Route path='/providerapproval' component={ProviderApproval} />
                <Route path='/OnlineProviderApprovalQualificationScope' component={OnlineProviderApprovalQualificationScope} />
                <Route path='/OnlineProviderApprovalUnitStandardScope' component={OnlineProviderApprovalUnitStandardScope} />
                <Route path='/OnlineProviderApprovalSkillsProgrammeScope' component={OnlineProviderApprovalSkillsProgrammeScope} />
                <Route path='/OnlineProviderApprovalLearnershipScope' component={OnlineProviderApprovalLearnershipScope} />
                <Route path='/OnlineProviderApprovalDocuments' component={OnlineProviderApprovalDocuments} />
                <Route path='/OnlineProviderDetailsVerification' component={OnlineProviderDetailsVerification} />

                <Route path='/SkillsLetterCreationSearch' component={SkillsLetterCreationSearch} />
                <Route path='/SkillsLetterCreation' component={SkillsLetterCreation} />
                <Route path='/SkillsQueryReasonSearch' component={SkillsQueryReasonSearch} />
                <Route path='/SkillsQueryReason' component={SkillsQueryReason} />
                <Route path='/SkillsRejectionReasonSearch' component={SkillsRejectionReasonSearch} />
                <Route path='/SkillsRejectionReason' component={SkillsRejectionReason} />
                <Route path='/SkillsTNumberConversionSearch' component={SkillsTNumberConversionSearch} />
                <Route path='/SkillsTNumberConversion' component={SkillsTNumberConversion} />

                <Route path='/maintenanceTargets' component={BenefitsTargetsSearch} />
                <Route path='/CreateInterventionTitles' component={CreateInterventionTitles} />
                <Route path='/maintenanceInterventionTitles' component={InterventionTitlesSearch} />
                <Route path='/maintenanceBenefitDescriptions' component={BenefitsDescriptionsSearch} />
                <Route path='/BenefitsDescriptionSearchForm' component={CreateBenefitsDescriptionSearch} />
                <Route path='/Benefits' component={BenefitsTargetAddFormSearch} />

                <Route path='/maintenanceLinking' component={LinkingSearch} />
                <Route path='/maintenanceBenefitsUploading' component={BenefitsUpload} />

                <Route path='/EmailAdd' component={EmailAdd} />
                <Route path='/maintenanceEmail' component={ClientsEmailsSearch} />

                <Route path='/moderator' component={Moderator} />
                <Route path='/moderatorRegistrationDetails' component={ModeratorRegistrationDetails} />


                <Route path='/providerSearch' component={ProviderSearch} />
                <Route path='/provider' component={Provider} />
                <Route path='/outcome' component={Outcome} />
                <Route path="/providerMonitoringAndEvaluation" component={ProviderMonitoringAndEvaluation} />
                <Route path="/providerTrade" component={ProviderTrade} />
                <Route path='/providerContacts' component={ProviderContact} />
                <Route path='/providerSiteVisits' component={ProviderSiteVisitsSearch} />
                <Route path='/providerUsers' component={ProviderUsers} />
                <Route path='/providerAccreditationDetails' component={ProviderAccreditation} />
                <Route path='/providerLearner' component={ProviderLearner} />
                <Route path='/providerUnitStandardSearch' component={ProviderUnitStandards} />
                <Route path='/providerQualificationUSSearch' component={ProviderQualificationUSSearch} />
                <Route path='/providerQualificationsSearch' component={ProviderQualificationSearch} />
                <Route path='/providerModuleQualificationsSearch' component={ProviderModuleQualificationsSearch} />
                <Route path='/providerSkillsProgrammeSearch' component={ProviderSkillsProgrammeSearch} />
                <Route path='/providerSkillsProgrammeUSSearch' component={ProviderSkillsProgrammeUSSearch} />
                <Route path='/providerLearnershipSearch' component={ProviderLearnershipSearch} />
                <Route path='/providerLearnershipUSSearch' component={ProviderLearnershipUSSearch} />
                <Route path='/providerAssessorSearch' component={ProviderAssessorSearch} />
                <Route path='/providerModeratorSearch' component={ProviderModeratorSearch} />
                <Route path="/providerAccreditationHistory" component={ProviderAccreditationHistory} />
                <Route path="/providerLogoApplication" component={ProviderLogoApplication} />


                <Route path='/learnerSkillsProgram' component={LearnerSkillsProgram} />

                <Route path='/bda' component={BDASearch} />
                <Route path='/personSearch' component={PersonSearch} />
                <Route path='/externalmoderators' component={ExternalProviderSearch} />
                <Route path='/assessorSearch' component={AssessorSearch} />
                <Route path='/auditTrial' component={AuditTrial} />
                <Route path='/assessor' component={Assessor} />
                <Route path='/unitstandardsetupSearch' component={UnitStandardSetupSearch} />
                <Route path='/unitStandardSetup' component={UnitStandardSetup} />
                <Route path='/qualificationsetupSearch' component={QualificationSetupSearch} />
                <Route path='/qualificationsetup' component={QualificationSetup} />
                <Route path='/qualunitstandardsearch' component={QualificationUnitStandardSearch} />
                <Route path='/qualmodulesearch' component={QualificationModuleSearch} />
                <Route path='/skillsProgramestandardsearch' component={SkillsUnitStandardSearch} />
                <Route path='/learnershipsetupSearch' component={LearnershipSetupSearch} />
                <Route path='/aetSetupSearch' component={AETSetupSearch} />
                <Route path='/AETsetup' component={AETSetup} />
                <Route path='/tradeSetupSearch' component={TradeSetupSearch} />
                <Route path='/Tradesetup' component={TradeSetup} />
                <Route path='/learnershipUnitStandardSearch' component={LearnershipUnitStandardSearch} />
                <Route path='/learnershipmodulesearch' component={LearnershipModuleSearch} />
                <Route path='/learnershipsetup' component={LearnershipSetup} />
                <Route path='/saqaxmlimport' component={SAQAXMLImport} />
                <Route path='/shortcoursesetup' component={ShortCourseSetupSearch} />
                <Route path='/skillsProgrammeSetupSearch' component={SkillsProgramSetupSearch} />
                <Route path='/skillsProgrammeSetup' component={SkillsProgramSetup} />
                <Route path='/artisansetup' component={ArtisansSetupSearch} />
                <Route path='/addLearnerFlow' component={AddLearnerFlow} />
                <Route path='/addPersonFlow' component={AddPersonFlow} />
                <Route path='/addAssessorFlow' component={AddAssessorFlow} />
                <Route path='/addModderatorFlow' component={AddModeratorFlow} />
                <Route path='/roleMaintenanceSearch' component={RoleMaintenanceSearch} />
                <Route path='/userMaintenanceSearch' component={UserMaintenanceSearch} />
                <Route path='/modulesetupSearch' component={ModuleSetupSearch} />
                <Route path='/moduleSetup' component={ModuleSetup} />

                <Route path='/userRole' component={UserRoleSearch} />


                <Route path='/userDetails' component={UserDetailsMaintenanceSearch} />

                <Route path='/LinkingSearch' component={CreateLinkingSearch} />

                <Route path='/roleMaintenance' component={Role} />
                <Route path='/rolePermissionSearch' component={RolePermissionSearch} />
                <Route path='/rolePermissionMaintenance' component={RolePermission} />
                <Route path='/SDFSearch' component={SDFSearch} />
                <Route path='/sdf' component={SDF} />
                <Route path='/sdfOrgDetails' component={SDFOrganisationDetails} />

                {/*DG Application*/}

                <Route path='/DGOrganisationSearch' component={DGOrganisationSearch} />
                <Route path='/DGOrganisation' component={DGOrganisation} />
                <Route path='/DGApplication' component={DGApplication} />
                <Route path='/DGApplicationDashboard' component={DGApplicationDashboard} />
                <Route path='/DGOrganisationContacts' component={DGOrganisationContact} />
                <Route path='/DGDocumentUploads' component={DGDocumentsUpload} />
                <Route path='/dgForms' component={DGForms} />
                <Route path='/DGVerificationSearch' component={DGVerificationSearch} />
                <Route path='/DGVerificationMain' component={DGVerificationMain} />
                <Route path='/DGEvaluationSearch' component={DGEvaluationSearch} />
                <Route path='/DGEvaluationMain' component={DGEvaluationMain} />
                <Route path='/DGApprovalSearch' component={DGApprovalSearch} />
                <Route path='/DGApprovalMain' component={DGApprovalMain} />
                <Route path="/DGContracts" component={DGContracts} />
                <Route path="/Artisan2022" component={ArtisanForm2022} />
                <Route path="/AET2022" component={AETForm2022} />
                <Route path="/Bursary2022" component={BursaryForm2022} />
                <Route path="/Learnership2022" component={LearnershipForm2022} />
                <Route path="/Candidacy2022" component={CandidacyForm2022} />
                <Route path="/TVET2022" component={TVETForm2022} />
                <Route path="/LearnershipRPL2022" component={LearnershipRPLForm2022} />
                <Route path="/Internship2022" component={InternshipForm2022} />
                <Route path="/SkillsProgramme2022" component={SkillsProgrammeForm2022} />
                <Route path="/SkillsProgrammeEU2022" component={SkillsProgrammeEUForm2022} />
                <Route path="/WorkExperience2022" component={WorkExperienceForm2022} />

                <Route path="/AET2023" component={AETForm2023} />
                <Route path="/Candidacy2023" component={CandidacyForm2023} />
                <Route path="/Internship2023" component={InternshipForm2023} />
                <Route path="/SkillsProgramme2023" component={SkillsProgrammeForm2023} />
                <Route path="/Learnership2023" component={LearnershipForm2023} />
                <Route path="/EntrepreneurshipProgramme2023" component={EntrepreneurshipProgrammeForm2023} />
                <Route path="/RPL2023" component={RPLForm2023} />
                <Route path="/Bursary2023" component={BursaryForm2023} />
                <Route path="/ShortCourse2023" component={ShortCourseForm2023} />
                <Route path="/WIL2023" component={WILForm2023} />
                <Route path="/MathScience2023" component={MathScienceForm2023} />
                <Route path="/WorkReadinessProgramme2023" component={WorkReadinessProgrammeForm2023} />
                <Route path="/AssistLearnersNotPassed2023" component={AssistLearnersNotPassedForm2023} />
                <Route path="/CapacityBuildingSupport2023" component={CapacityBuildingSupportForm2023} />
                <Route path="/CareerGuidanceWorkshop2023" component={CareerGuidanceWorkshopForm2023} />
                <Route path="/DigitalLiteracyProgramme2023" component={DigitalLiteracyProgrammeForm2023} />
                <Route path="/Qualification2023" component={QualificationForm2023} />

                <Route path="/AET2024" component={AETForm2024} />
                <Route path="/Candidacy2024" component={CandidacyForm2024} />
                <Route path="/Internship2024" component={InternshipForm2024} />
                <Route path="/SkillsProgramme2024" component={SkillsProgrammeForm2024} />
                <Route path="/Learnership2024" component={LearnershipForm2024} />
                <Route path="/EntrepreneurshipProgramme2024" component={EntrepreneurshipProgrammeForm2024} />
                <Route path="/RPL2024" component={RPLForm2024} />
                <Route path="/Bursary2024" component={BursaryForm2024} />
                <Route path="/ShortCourse2024" component={ShortCourseForm2024} />
                <Route path="/WIL2024" component={WILForm2024} />
                <Route path="/MathScience2024" component={MathScienceForm2024} />
                <Route path="/WorkReadinessProgramme2024" component={WorkReadinessProgrammeForm2024} />
                <Route path="/AssistLearnersNotPassed2024" component={AssistLearnersNotPassedForm2024} />
                <Route path="/CapacityBuildingSupport2024" component={CapacityBuildingSupportForm2024} />
                <Route path="/CareerGuidanceWorkshop2024" component={CareerGuidanceWorkshopForm2024} />
                <Route path="/DigitalLiteracyProgramme2024" component={DigitalLiteracyProgrammeForm2024} />
                <Route path="/Qualification2024" component={QualificationForm2024} />

                <Route path='/StakeholderSearch' component={StakeholderSearch} />
                <Route path='/Stakeholder' component={Stakeholder} />
                <Route path='/StakeholderOrganisationDetails' component={StakeholderOrganisationDetails} />
                <Route path='/DGOrganisationStakeholder' component={OrganisationStakeholder} />
                <Route path='/DGOrganisationCRM' component={DGOrganisationCRM} />

                <Route path="/AET2025" component={AETForm2025} />
                <Route path="/Candidacy2025" component={CandidacyForm2025} />
                <Route path="/Internship2025" component={InternshipForm2025} />
                <Route path="/SkillsProgramme2025" component={SkillsProgrammeForm2025} />
                <Route path="/Learnership2025" component={LearnershipForm2025} />
                <Route path="/EntrepreneurshipProgramme2025" component={EntrepreneurshipProgrammeForm2025} />
                <Route path="/RPL2025" component={RPLForm2025} />
                <Route path="/Bursary2025" component={BursaryForm2025} />
                <Route path="/ShortCourse2025" component={ShortCourseForm2025} />
                <Route path="/WIL2025" component={WILForm2025} />
                <Route path="/MathScience2025" component={MathScienceForm2025} />
                <Route path="/WorkReadinessProgramme2025" component={WorkReadinessProgrammeForm2025} />
                <Route path="/AssistLearnersNotPassed2025" component={AssistLearnersNotPassedForm2025} />
                <Route path="/CapacityBuildingSupport2025" component={CapacityBuildingSupportForm2025} />
                <Route path="/CareerGuidanceWorkshop2025" component={CareerGuidanceWorkshopForm2025} />
                <Route path="/DigitalLiteracyProgramme2025" component={DigitalLiteracyProgrammeForm2025} />
                <Route path="/Qualification2025" component={QualificationForm2025} />

                <Route path="/AET2026" component={AETForm2026} />
                <Route path="/Candidacy2026" component={CandidacyForm2026} />
                <Route path="/Internship2026" component={InternshipForm2026} />
                <Route path="/SkillsProgramme2026" component={SkillsProgrammeForm2026} />
                <Route path="/Learnership2026" component={LearnershipForm2026} />
                <Route path="/EntrepreneurshipProgramme2026" component={EntrepreneurshipProgrammeForm2026} />
                <Route path="/RPL2026" component={RPLForm2026} />
                <Route path="/Bursary2026" component={BursaryForm2026} />
                <Route path="/ShortCourse2026" component={ShortCourseForm2026} />
                <Route path="/WIL2026" component={WILForm2026} />
                <Route path="/MathScience2026" component={MathScienceForm2026} />
                <Route path="/WorkReadinessProgramme2026" component={WorkReadinessProgrammeForm2026} />
                <Route path="/AssistLearnersNotPassed2026" component={AssistLearnersNotPassedForm2026} />
                <Route path="/CapacityBuildingSupport2026" component={CapacityBuildingSupportForm2026} />
                <Route path="/CareerGuidanceWorkshop2026" component={CareerGuidanceWorkshopForm2026} />
                <Route path="/DigitalLiteracyProgramme2026" component={DigitalLiteracyProgrammeForm2026} />
                <Route path="/Qualification2026" component={QualificationForm2026} />

                {/*End DG Application*/}

                <Route path='/skillsOrganisationSearch' component={OrganisationSearch} />
                <Route path='/skillsOrganisation' component={Organisation} />
                <Route path='/skillsChildOrganisation' component={ChildOrganisation} />
                <Route path='/skillsOrganisationContacts' component={OrganisationContact} />
                <Route path='/skillsOrganisationBankingDetails' component={OrganisationBankingDetails} />
                <Route path='/skillsChildOrganisationSearch' component={ChildOrganisationSearch} />
                <Route path='/skillsOrganisationCFODetails' component={OrganisationCFODetails} />
                <Route path='/skillsTrainingCommitteeSearch' component={TrainingCommitteeSearchRecord} />
                <Route path='/skillsTrainingCommittee' component={TrainingCommittee} />
                <Route path='/skillsUnion' component={UnionSearchRecord} />
                <Route path='/skillsOrganisationSDF' component={OrganisationSDF} />
                <Route path='/skillsOrganisationLevies' component={OrganisationGrantsLevies} />
                <Route path='/Levies' component={Levies} />
                <Route path='/skillsOrganisationGrants' component={Grants} />
                <Route path='/skillsOrganisationDiscretionaryGrants' component={DiscretionaryGrants} />
                <Route path='/skillsOrganisationInterSetaTransfer' component={InterSetaTransfer} />
                <Route path='/skillsOrganisationLetter' component={SDFComplianceLetter} />

                <Route path='/EmployerFileImport' component={EmployerFileImport} />

                <Route path="/WspAtrForms" component={WspAtrForms} />
                <Route path="/HardToFillVacancies2023" component={HardToFillVacanciesForm2023} />
                <Route path="/CommonSkillsGaps2023" component={CommonSkillsGapsForm2023} />
                <Route path="/CurrentEmploymentProfile2023" component={EmploymentProfileForm2023} />
                <Route path="/PlannedBeneficiariesTrainingEmployed2023" component={PlannedBeneficiariesEmployedForm2023} />
                <Route path="/PlannedBeneficiariesTrainingUnemployed2023" component={PlannedBeneficiariesUnemployedForm2023} />
                <Route path="/PlannedAET2023" component={PlannedAETForm2023} />
                <Route path="/HighestEducationProfile2023" component={HighestEducationProfileForm2023} />
                <Route path="/SummaryTrainingReport2023" component={TrainingReportSummaryForm2023} />
                <Route path="/TrainingReportEmployed2023" component={TrainingReportEmployedForm2023} />
                <Route path="/TrainingReportUnemployed2023" component={TrainingReportUnemployedForm2023} />
                <Route path="/CompletedAET2023" component={CompletedAETForm2023} />
                <Route path="/EmploymentProfileSmall2023" component={EmploymentProfileSmallForm2023} />

                <Route path="/HardToFillVacancies2024" component={HardToFillVacanciesForm2024} />
                <Route path="/CommonSkillsGaps2024" component={CommonSkillsGapsForm2024} />
                <Route path="/CurrentEmploymentProfile2024" component={EmploymentProfileForm2024} />
                <Route path="/PlannedBeneficiariesTrainingEmployed2024" component={PlannedBeneficiariesEmployedForm2024} />
                <Route path="/PlannedBeneficiariesTrainingUnemployed2024" component={PlannedBeneficiariesUnemployedForm2024} />
                <Route path="/PlannedAET2024" component={PlannedAETForm2024} />
                <Route path="/HighestEducationProfile2024" component={HighestEducationProfileForm2024} />
                <Route path="/SummaryTrainingReport2024" component={TrainingReportSummaryForm2024} />
                <Route path="/TrainingReportEmployed2024" component={TrainingReportEmployedForm2024} />
                <Route path="/TrainingReportUnemployed2024" component={TrainingReportUnemployedForm2024} />
                <Route path="/CompletedAET2024" component={CompletedAETForm2024} />
                <Route path="/EmploymentProfileSmall2024" component={EmploymentProfileSmallForm2024} />
                <Route path="/ProvincialDetails2024" component={ProvincialDetailsForm2024} />

                <Route path="/HardToFillVacancies2025" component={HardToFillVacanciesForm2025} />
                <Route path="/CommonSkillsGaps2025" component={CommonSkillsGapsForm2025} />
                <Route path="/CurrentEmploymentProfile2025" component={EmploymentProfileForm2025} />
                <Route path="/PlannedBeneficiariesTrainingEmployed2025" component={PlannedBeneficiariesEmployedForm2025} />
                <Route path="/PlannedBeneficiariesTrainingUnemployed2025" component={PlannedBeneficiariesUnemployedForm2025} />
                <Route path="/PlannedAET2025" component={PlannedAETForm2025} />
                <Route path="/HighestEducationProfile2025" component={HighestEducationProfileForm2025} />
                <Route path="/SummaryTrainingReport2025" component={TrainingReportSummaryForm2025} />
                <Route path="/TrainingReportEmployed2025" component={TrainingReportEmployedForm2025} />
                <Route path="/TrainingReportUnemployed2025" component={TrainingReportUnemployedForm2025} />
                <Route path="/CompletedAET2025" component={CompletedAETForm2025} />
                <Route path="/EmploymentProfileSmall2025" component={EmploymentProfileSmallForm2025} />
                <Route path="/ProvincialDetails2025" component={ProvincialDetailsForm2025} />

                <Route path="/HardToFillVacancies2026" component={HardToFillVacanciesForm2026} />
                <Route path="/CommonSkillsGaps2026" component={CommonSkillsGapsForm2026} />
                <Route path="/CurrentEmploymentProfile2026" component={EmploymentProfileForm2026} />
                <Route path="/PlannedBeneficiariesTrainingEmployed2026" component={PlannedBeneficiariesEmployedForm2026} />
                <Route path="/PlannedBeneficiariesTrainingUnemployed2026" component={PlannedBeneficiariesUnemployedForm2026} />
                <Route path="/PlannedAET2026" component={PlannedAETForm2026} />
                <Route path="/HighestEducationProfile2026" component={HighestEducationProfileForm2026} />
                <Route path="/SummaryTrainingReport2026" component={TrainingReportSummaryForm2026} />
                <Route path="/TrainingReportEmployed2026" component={TrainingReportEmployedForm2026} />
                <Route path="/TrainingReportUnemployed2026" component={TrainingReportUnemployedForm2026} />
                <Route path="/CompletedAET2026" component={CompletedAETForm2026} />
                <Route path="/EmploymentProfileSmall2026" component={EmploymentProfileSmallForm2026} />
                <Route path="/ProvincialDetails2026" component={ProvincialDetailsForm2026} />

                <Route path="/wspAtrDashboard" component={WspAtrDashboard} />
                <Route path="/WspAtrDocumentsUpload" component={WspAtrDocumentsUpload} />
                <Route path="/WSPATRVerificationMain" component={WSPATRVerificationMain} />
                <Route path="/WspAtrVerification" component={WspAtrVerification} />
                <Route path="/WSPATREvaluation" component={WSPATREvaluation} />
                <Route path="/WSPATREvaluationMain" component={WSPATREvaluationMain} />
                <Route path="/WSPATRApprovalMain" component={WSPATRApprovalMain} />
                <Route path="/WspAtrApproval" component={WspAtrApproval} />
                <Route path="/Approval" component={Approval} />
                <Route path="/Evaluation" component={Evaluation} />
                <Route path="/Verification" component={Verification} />
                <Route path="/StackhoderFeedback" component={Feedback} />
                <Route path="/WspAtrLodgeApeal" component={LodgeApeal} />
                <Route path="/WspAtrExtensionRequest" component={RequestExtension} />


                <Route path='/ETQAReportSearch' component={ETQAReportSearch} />
                <Route path='/ETQAReport' component={ETQAReport} />
                <Route path='/SkillsReportSearch' component={SkillsReportSearch} />
                <Route path='/SkillsReport' component={SkillsReport} />
                <Route path='/MasterFileSearch' component={MasterFileSearch} />
                <Route path='/MasterFile' component={MasterFile} />
                <Route path='/SETMISFileSearch' component={SETMISFileSearch} />
                <Route path='/SETMISFile' component={SETMISFile} />
                <Route path='/DGReportSearch' component={DGReportSearch} />
                <Route path='/DGReport' component={DGReport} />
                <Route path='/CustomReports' component={CustomReports} />
                <Route path='/CustomReportsV2' component={CustomReportsV2} />
                <Route path='/AdminReportSearch' component={AdminReportSearch} />
                <Route path='/AdminReport' component={AdminReport} />
                <Route path='/ProviderReportSearch' component={ProviderReportSearch} />
                <Route path='/ProviderReport' component={ProviderReport} />
                <Route path='/EmployerReportSearch' component={EmployerReportSearch} />
                <Route path='/EmployerReport' component={EmployerReport} />

                <Route path="/providerDocuments" component={ProviderDocuments} />
                <Route path="/assessorDocuments" component={AssessorDocuments} />
                <Route path="/moderatorDocuments" component={ModeratorDocuments} />
                <Route path="/learnerDocuments" component={LearnerDocuments} />
                <Route path="/bulkApproval" component={BulkApproval} />
                <Route path="/expiryNotification" component={ExpiryNotification} />
                <Route path="/learnerendorsementletter" component={LearnerEndorsementLetter} />
                <Route path="/ProofOfRegistration" component={POR} />

                <Route path='/GrantSetupSearch' component={GrantSetupSearch} />
                <Route path='/AddEditTranche' component={AddEditTranche} />
                <Route path='/TrancheDetails' component={TrancheDetails} />
                <Route path='/ProcessingNav' component={ProcessingNav} />
                <Route path='/GenerateClaim' component={GenerateClaimSearch} />
                <Route path='/ApproveClaim' component={ApproveClaimSearch} />
                <Route path='/GrantClaimFormReversal' component={GrantClaimFormReversalSearch} />
                <Route path='/DownloadClaim' component={DownloadClaimSearch} />
                <Route path='/GenerateBatch' component={GenerateBatchSearch} />
                <Route path='/DownloadBatch' component={DownloadBatchSearch} />
                <Route path='/AXProcessor' component={AXProcessorSearch} />
                <Route path='/GrantReversals' component={GrantReversalsSearch} />
                <Route path='/BulkGrantAssociation' component={BulkGrantAssociation} />
                <Route path='/BulkGrantDeAssociation' component={BulkGrantDeAssociation} />

                {/*Helpdesk*/}
                <Route path='/HelpdeskRequestSearch' component={HelpdeskRequestSearch} />
                <Route path='/HelpdeskRequest' component={HelpdeskRequest} />
                <Route path='/HelpDeskReport' component={HelpDeskReport} />
                {/*End Helpdesk*/}

                <Route path='/AudienceOptions' component={AudienceOptions} />


                <Route path='/qalpdashboard' component={QALPDashboard} />
                <Route path='/mgdashboard' component={MGDashboard} />
                <Route path='/dgdashboard' component={DGDashboard} />

                <Route path='/IDVerificationPortal' component={IDVerificationPortal} />
                <Route path='/skillsprogrammemodulesearch' component={SkillsProgrammeModuleSearch} />

            </span>
        );
    }
}

export default withRouter(connect()(Routes));
